/**
 * Format a US phone number as "(111)111-1111" (no space after the area code).
 * Strips non-digits and drops a leading US country code. Returns the input
 * untouched when it isn't a recognizable 10-digit number, so foreign or
 * partial values aren't mangled.
 */
export function formatPhone(raw: string | null | undefined): string {
  if (!raw) return '';
  const digits = raw.replace(/\D/g, '');
  const national =
    digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  if (national.length === 10) {
    return `(${national.slice(0, 3)})${national.slice(3, 6)}-${national.slice(6)}`;
  }
  return raw;
}
